import React, { useContext, useState } from "react";
import Topbar from "../../../components/TopBarComponent/Topbar";
import TableBody from "../../../constants/dummyData.json";
import { Container, Nav, Tab, Tabs } from "react-bootstrap";
import Button from "../../../components/ButtonComponent/Button";
import BackArrow from "../../../assets/images/Icons/backArrow.svg";
import DataTable from "../../../components/DataTableComponent/DataTable";
import EditIcon from "../../../assets/images/Icons/pencilIcon.svg";
import ActiveIcon from "../../../assets/images/Icons/activeEyeIcon.svg";
import UploadIcon from "../../../assets/images/uploadIcon.svg";
import InactiveIcon from "../../../assets/images/Icons/inactiveEyeIcon.svg";
import { SettingsContext } from "../SettingsView";
import AlertBox from "../../../components/AlertComponent/AlertBox";
import { baseURL } from "../../../api/Axios";
import ExcelIcon from "../../../assets/images/Icons/xlIcon.svg";
import "./settings.css";
import { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import DropDownItem from "../../../components/DropDownComponent/DropDown";
const Settings = ({ textContent }) => {
  const Content = TableBody.settingsData;
  const {
    navigateToPermissions,
    goBack,
    navigateToEditDevice,
    navigateToAddDevice,
    isEdit,
    getDeviceData,
    deviceList,
    createDeviveData,
    alertMessage,
    handleAlertSubmit,
    setAlertMessage,
    showAlert,
    setShowAlert,
    logout,
    statusCode,
    handleMagneticUpload,
    setFileErrorMessage,
    spinnerStatus,
    fileErrorMessage,
    visitorCardSubmit,
    cardExcel,
    cardFileDownload,
    // new changes
    extentendStayValue,
    setExtentendStayValue,
    submitExtentedStayData,
    setExtentedStayRequired,
    navigate,
    getExtentedStayValue,
    extentedSpinnerStatus,
  } = useContext(SettingsContext);

  const requiredKey = "permissions";
  const changeToPermissions = (tab) => {
    tab === requiredKey ? navigateToPermissions() : null;
    getExtentedStayValue();
  };

  const deviceSettingsHeader = [
    { title: "IP Address", prop: "ip" },
    { title: "Entry Type", prop: "EntryType" },
    { title: "Device Direction", prop: "Activity" },
    { title: "Zone", prop: "Zone" },
    // {
    //   prop: "status1",
    //   cell: (row) => (
    //     <div className="editable-buttons">
    //       {row.status1 == "active" ? (
    //         <img
    //           className="settings-able-button"
    //           src={ActiveIcon}
    //           alt="status icon"
    //         />
    //       ) : (
    //         <img
    //           className="settings-able-button"
    //           src={InactiveIcon}
    //           alt="status icon"
    //         />
    //       )}
    //       <img
    //         src={EditIcon}
    //         alt="Edit icon"
    //         onClick={() => {
    //           navigateToEditDevice(row);
    //         }}
    //       />
    //     </div>
    //   ),
    // },
  ];
  useEffect(() => {
    getDeviceData();
  }, []);
  const extentedTimeList = [
    {
      id: 1,
      name: "9",
    },
    // {
    //   id: 2,
    //   name: "8",
    // },
    {
      id: 3,
      name: "10",
    },
    {
      id: 4,
      name: "11",
    },
    {
      id: 5,
      name: "12",
    },
    {
      id: 6,
      name: "13",
    },
    {
      id: 7,
      name: "14",
    },

    {
      id: 8,
      name: "15",
    },

    {
      id: 9,
      name: "16",
    },

    {
      id: 10,
      name: "17",
    },
    {
      id: 11,
      name: "18",
    },

    {
      id: 12,
      name: "19",
    },
    {
      id: 13,
      name: "20",
    },
    {
      id: 14,
      name: "21",
    },
    {
      id: 15,
      name: "22",
    },
    {
      id: 16,
      name: "13",
    },
    {
      id: 17,
      name: "14",
    },

    {
      id: 18,
      name: "15",
    },
    {
      id: 19,
      name: "16",
    },
    {
      id: 20,
      name: "17",
    },

    {
      id: 21,
      name: "18",
    },
    {
      id: 22,
      name: "19",
    },
    {
      id: 23,
      name: "20",
    },

    {
      id: 24,
      name: "21",
    },
    {
      id: 25,
      name: "22",
    },
    {
      id: 26,
      name: "23",
    },

    {
      id: 27,
      name: "24",
    },
  ];
  const handleCancel = () => {
    //console.log("adSD");
    //navigate(-1);
  };

  return (
    <div className="settings">
      <Topbar />
      <Container className="my-4">
        <Tabs
          defaultActiveKey="device-settings"
          id="uncontrolled-tab-example"
          onSelect={(e) => {
            changeToPermissions(e);
          }}
        >
          <Tab
            eventKey="permissions"
            title={textContent.permissions.toUpperCase()}
          ></Tab>

          <Tab eventKey="visitor-card" title="VISITORS CARD">
            <div className="heading-row my-3">
              <div className="title-box">
                <img
                  className="back-arrow"
                  src={BackArrow}
                  alt="Back Arrow"
                  width={17}
                  onClick={() => goBack()}
                />
                <p className="title-name">{textContent.magneticTitle}</p>
              </div>
              <p className={"download-text"}>
                <a
                  className={"excel-download"}
                  href={
                    cardFileDownload
                      ? `${baseURL}/excel/${cardFileDownload}`
                      : null
                  }
                >
                  <img
                    className="excel-icon"
                    src={ExcelIcon}
                    alt="Excel-icon"
                  />
                  Download Visitors Card
                </a>
              </p>
            </div>
            <form onSubmit={visitorCardSubmit} className="uploadCradSection">
              <div className="uploadMagneticCardData">
                <label className="uploadPhotoContainerGuest">
                  <img src={UploadIcon} alt="img" />
                  <span className="uploadTextRegister">
                    {cardExcel ? cardExcel : "UPLOAD"}
                  </span>
                  <input
                    className="input-group-text"
                    type={"file"}
                    onChange={handleMagneticUpload}
                  />
                </label>
                <p className="mb-0 error-msg">
                  {fileErrorMessage ? fileErrorMessage : ""}
                </p>
              </div>
              <div className="fileSubmitBtns">
                <button type="submit" className="button">
                  {spinnerStatus ? <Spinner size="sm" /> : "Submit"}
                </button>
              </div>
            </form>
          </Tab>

          <Tab
            eventKey="device-settings"
            title={textContent.deviceSettings.toUpperCase()}
          >
            <div className="heading-row my-3">
              <div className="title-box">
                <img
                  onClick={() => goBack()}
                  className="back-arrow"
                  src={BackArrow}
                  alt="Back Arrow"
                  width={22}
                />
                <p className="title-name">{textContent.deviceSettings}</p>
              </div>
            </div>
            <DataTable
              tableData={deviceList[0]}
              header={deviceSettingsHeader}
              isPagination={false}
            />
          </Tab>
          {/* // new changed */}
       
            <Tab eventKey="extented-stay" title="EXTENTED STAY">
              <div className="heading-row my-3">
                <div className="title-box">
                  <img
                    onClick={() => goBack()}
                    className="back-arrow"
                    src={BackArrow}
                    alt="Back Arrow"
                    width={22}
                  />
                  <p className="title-name">Extended Stay Settings</p>
                </div>
              </div>
              <form
                onSubmit={submitExtentedStayData}
                className="extentedsection"
              >
                <div className="extendstaymaindiv">
                  <div className="extentedsectiondropdown drop-item error-alert dropdown">
                    <label className="extentedlabel">Extended Hour</label>
                    <DropDownItem
                      list={extentedTimeList}
                      selectedItem={extentendStayValue}
                      setSelectedItem={setExtentendStayValue}
                      categoryRequired={setExtentedStayRequired}
                    />
                  </div>
                  <div className="button-group-extented">
                    <button type="submit" className="extentedSaveBtn">
                      Save
                    </button>
                  </div>
                </div>
              </form>
              {extentedSpinnerStatus && (
                <div className="spinner-overlay">
                  <Spinner size="xl" className="custom-spinner" />
                </div>
              )}
            </Tab>
        
        </Tabs>
        <AlertBox
          show={showAlert}
          setShow={setShowAlert}
          alertMessage={alertMessage}
          handleSubmit={
            statusCode == 401 ? () => logout() : () => handleAlertSubmit()
          }
        />
      </Container>
    </div>
  );
};

export default Settings;
